import { useNavigate, useLocation } from 'react-router-dom';
import { savePostAuthRedirect } from '../utils/authRedirect';
import { useUser } from '../contexts/UserContext';
import { useJobModal } from '../contexts/JobModalContext';

/**
 * Call inside an event handler. If the user is not logged in, they will be
 * redirected to /auth/login and the current path will be restored after auth.
 * Returns true if the user is authenticated, false otherwise.
 */
export const useRequireLogin = () => {
  const { isAuthenticated, isLoading } = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  const { closeJobModal } = useJobModal();

  const requireLogin = () => {
    if (isLoading || isAuthenticated) return true;

    // Save where the user wanted to go and kick to login
    savePostAuthRedirect(location.pathname + location.search);

    // Gracefully close any open job modal to prevent blank page overlay
    closeJobModal();

    navigate('/auth/login');
    return false;
  };

  return requireLogin;
}; 